import { useQuery } from "@tanstack/vue-query";

import { CurrentUserQueryKeys } from "@/data/api/kili/current-user/current-user-query-keys";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetCurrentUserQuery() {
  return useQuery({
    queryKey: CurrentUserQueryKeys.getCurrentUser(),
    queryFn: async () => KiliApi.getCurrentUser(),
  });
}
